<span class="form-field-label" *ngIf="fieldLabel">
  {{ fieldLabel }}
</span>
<div class="search-select" [class.disabled]="control.disabled" (click)="onClick()">
  <input matInput readonly [formControl]="control" [placeholder]="placeholder" />
  <div #ref class="icon-custom"><ng-content></ng-content></div>
  <ng-container *ngIf="ref.children.length; else arrow"></ng-container>

</div>

<ng-template #arrow>
  <div class="arrow-wrapper">
    <ng-container [ngSwitch]="arrowType">
      <ng-container *ngSwitchCase="0" [ngTemplateOutlet]="type0"> </ng-container>
      <ng-container *ngSwitchCase="1" [ngTemplateOutlet]="type1"> </ng-container>

    </ng-container>
  </div>
</ng-template>

<ng-template #type0>
  <div class="arrow"></div>
</ng-template>


<ng-template #type1>
  <!-- <div class="arrow"></div> -->
  <mat-icon svgIcon="expand" class="custom-expand"></mat-icon>
</ng-template>